<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <ProfileForm
      v-if="showForm && !showModuleActionsForm"
      :profile="profile"
      :profileId="profileId()"
      :structureOptions="structureOptions"
      @click:module="goToModule"
      @click:submit="submit"
    >
    </ProfileForm>
    <ModuleActionsForm
      v-if="showModuleActionsForm"
      :modulo="selectedModule"
      @close-module="showModuleActionsForm = false"
      @save-module="saveModuleActions"
    >
    </ModuleActionsForm>
    <ModalCancelProfile
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>

<script>
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ProfileForm from "@/modules/profile/components/ProfileForm.vue";
import ModuleActionsForm from "@/modules/profile/components/ModuleActionsForm.vue";
import _ from "lodash";
import ModalCancelProfile from "../../insurance_company/components/ModalCancelInsurance";
import FormMixin from "@/mixins/FormMixin";
export default {
  name: "ProfileDetails",
  beforeRouteLeave(to, from, next) {
    if (
      this.cancel ||
      this.formIsPristineCommon(this.profile, this.cloneProfile)
    )
      next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  components: {
    ProfileForm,
    ModuleActionsForm,
    ModalCancelProfile
  },
  mixins: [LoadingRequest, FormMixin],
  data: () => ({
    profile: {},
    showForm: false,
    showModuleActionsForm: false,
    selectedModule: {},
    modalCancel: false,
    cancel: false,
    nextRoute: null,
    cloneProfile: {}
  }),
  computed: {
    breadcrumb() {
      let title = "";
      if (!this.showModuleActionsForm) {
        title = this.profileId()
          ? "Perfil de Acesso: " + (this.profile.nome || "")
          : "Novo Perfil de Acesso";
      } else {
        title = "Módulo de " + this.selectedModule.nome;
      }
      return [
        {
          text: title,
          to: ""
        }
      ];
    }
  },
  methods: {
    ...mapActions("profile", [
      "requestProfile",
      "editProfile",
      "createProfile",
      "requestStructureSuggestion",
      "requestModuleList"
    ]),
    ...mapActions(["showAlertNotification"]),
    async fetchData() {
      this.profile = this.profileId()
        ? await this.withLoading(
            this.requestProfile({ profileId: this.profileId() })
          )
        : { modulos: [] };
      this.structureOptions = await this.withLoading(
        this.requestStructureSuggestion()
      );
      if (this.profile.modulos.length === 0) {
        let moduleOptions = await this.withLoading(this.requestModuleList());
        this.initModuleOptions(moduleOptions);
        this.profile.modulos = moduleOptions;
      }
      this.cloneProfile = _.cloneDeep(this.profile);
      this.showForm = true;
    },
    profileId() {
      const id = this.$route.params.profileId;
      return id !== "novo-perfil" && id;
    },
    async submit() {
      const payload = _.omit(this.profile, ["id", "status"]);
      if (this.profileId()) {
        await this.withLoading(
          this.editProfile({ profileId: this.profileId(), payload: payload })
        );
      } else {
        await this.withLoading(this.createProfile(payload));
      }
      this.showAlertNotification({
        message: `Perfil foi salvo com sucesso.`,
        type: "success"
      });
      this.cancel = true;
      this.previousPage();
    },
    previousPage() {
      if (!this.showModuleActionsForm) {
        this.$router.push({ name: "profile" });
      } else {
        this.showModuleActionsForm = false;
      }
    },
    initModuleOptions(moduleOptions) {
      moduleOptions.forEach(moduleOption => {
        moduleOption.acoes.forEach(acao => {
          acao.selecionado = false;
        });
        moduleOption.habilitado = false;
      });
    },
    goToModule(item) {
      this.selectedModule = item;
      this.showModuleActionsForm = true;
    },
    saveModuleActions(actions) {
      this.selectedModule.acoes = actions;
      this.selectedModule.habilitado = actions.some(
        action => action.selecionado
      );
      this.showModuleActionsForm = false;
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
